import { api } from "@/lib/api";

export const getDigestPreview = () => api.get("/digest/preview").then((r) => r.data);
export const sendMyDigest = () => api.post("/digest/send-mine").then((r) => r.data);
export const sendTeamDigest = () => api.post("/digest/send-team").then((r) => r.data);
export const sendAllBdrDigests = () => api.post("/digest/send-all-bdrs").then((r) => r.data);
export const updateUserRole = (userId, role) => api.patch(`/team/users/${userId}/role`, { role }).then((r) => r.data);
